document.addEventListener("DOMContentLoaded", function() {
	$('.footer-contact__highlight__tab-nav .link').click(function(e) {
		e.preventDefault();
		// Update tabs
		$('.footer-contact__highlight__tab-nav .link').attr('tabindex', '-1');
		$(this).attr('tabindex', '0');
		// Show related content
		$('.footer-contact__highlight-all.tab-content, .footer-contact__highlight-experts.tab-content')
			.removeClass('d-block')
			.addClass('d-none');
		console.log($(this).attr('href'), $($(this).attr('href')));
		$($(this).attr('href'))
			.removeClass('d-none')
			.addClass('d-block');
	});
});
